module.exports = __webpack_public_path__ + "../resources/img/weather_cloudy.b8c0ecaf.svg";